import React from 'react'

class RadioInput extends React.Component {

  render() {
  	console.log(this.props.selection)
    return (
    	<div>

	    <div class="form-group radio_input">
    	<p>{this.props.question}</p>
		{ (this.props.question_options) ? (
        	this.props.question_options.map((option, index) => {
	            return (<label class="container_radio "> {option.text}
	            <input  
	            	checked = {this.props.selection[option.id]}
	            	id={option.id} 
	            	onChange={el => this.props.handler(el, this.props.id)} 
	            	type="radio" 
	            	name={option.text} 
	            	value={option.id} 
	            	class="required" />
	            
		    	{(this.props.required && index === 0) ? <span class="error">Required</span> : false}
	            <span class="checkmark"></span>
	            </label>
	        )})
	           
		  ) : false 
		  } 
		</div>
      </div>
    );
  }
}

export default RadioInput


// WEBPACK FOOTER //
// ./src/components/RadioInput.js